










































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CustomerContactInfo } from '@/models/filebunker/deal';
import { ValidateHelper } from '@/helper/validate.helper';
import { Base } from './base';
import {emailService} from '@/shared';

@Component({
    computed: {
        trigger: {
            get() {
                return this.$props.flag;
            },
            set(val) {
                if (!val) {
                    this.$emit('closedialog', val);
                }
            },
        },
        customer: {
            get() {
                return this.customerInfo;
            },
            set(info) {
                this.customer = info;
            },
        },
        to: {
            get() {
                return this.customer.to;
            },
            set(val: string[]) {
                const invalid: string[] = [];
                val.forEach((m) => {
                    if (!ValidateHelper.isEmail(m)) {
                        invalid.push(m);
                    }
                });
                invalid.forEach((email) => {
                    val.splice(val.indexOf(email), 1);
                });
                this.customer.to = val;
            },
        },
        cc: {
            get() {
                return this.customer.cc;
            },
            set(val) {
                const invalid: string[] = [];
                val.forEach((m) => {
                    if (!ValidateHelper.isEmail(m)) {
                        invalid.push(m);
                    }
                });
                invalid.forEach((email) => {
                    val.splice(val.indexOf(email), 1);
                });
                this.customer.cc = val;
            },
        },
    },
    watch: {
        'customer.to'(newVal, oldVal) {
            console.log(newVal);
        },
    },
    props: ['customerInfo', 'flag', 'url', 'loading'],
})

export default class EmailAttachmentComponent extends Base {
    public selectedPhoneType: string;
    public trigger: boolean;
    public email: string;
    public customerInfo: CustomerContactInfo;
    public customer: CustomerContactInfo;
    public url: string;
    public id: string;
    public requestProgress: boolean = false;
    public mounted(): void {
        // mounted block
    }
    public removeEmail(email: string, array: string[]): void {
        const index = array.indexOf(email);
        if (index > -1) {
            array.splice(index, 1);
            this.customer.to = [...array];
        }
    }
    public async sendAttachment(): Promise<void> {
        if(this.validateForm()){
            if(!this.customerInfo.to){
                return;
            }
            try {
                this.requestProgress = true;
                await emailService.sendEmail(this.url, this.customerInfo);
                this.showAlert(true, this.$t('sendAttachment.alertEmailSentSuccessfully'));
            } finally {
                this.requestProgress = false;
                this.$emit('closedialog', false);
            }
        }
    }
}
